import React, { Component } from "react"
import StatisticsActivity from "../../components/StatisticActivity"
import StatisticProduct from "../../components/StatisticProduct"
import Preloader from "../../components/Preloader"
import "./style.scss"

export class StatisticsPage extends Component {
    constructor(props) {
        super(props)
        this.state = {
            check: 0,
            activity: true,
        }
    }
    callbackFunction = (childData) => {
        this.setState({ activity: childData })
    }

    handleClick = (index) => {
        // const { activity } = this.state
        // if (activity) {
        //     this.setState({ check: index, activity: false })
        // }
        this.setState({ check: index })
    }

    render() {
        const { check, activity } = this.state
        // console.log("activity", activity)
        return (
            <div>
                <div className="sts-header">
                    <div
                        className={check == 0 ? "sts-item active" : "sts-item"}
                        onClick={() => this.handleClick(0)}
                    >
                        Overall
                    </div>
                    <div
                        className={check == 1 ? "sts-item active" : "sts-item"}
                        onClick={() => this.handleClick(1)}
                    >
                        Product
                    </div>
                </div>
                <div className="sts-body">
                    {check == 0 ? (
                        <StatisticsActivity  />
                    ) : (
                        ""
                    )}
                </div>
                <div className="sts-body">
                    {check == 1 ? <StatisticProduct /> : ""}
                </div>
                {/* {!activity ? <Preloader /> : null} */}
            </div>
        )
    }
}

export default StatisticsPage
